import { render } from "./section-detail.vue?vue&type=template&id=ea1eaa5c&scoped=true&ts=true"
import script from "./section-detail.vue?vue&type=script&lang=ts"
export * from "./section-detail.vue?vue&type=script&lang=ts"

import "./section-detail.vue?vue&type=style&index=0&id=ea1eaa5c&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea1eaa5c"]])

export default __exports__